import { render, staticRenderFns } from "./DeleLogin.vue?vue&type=template&id=15e532b4&scoped=true&"
import script from "./DeleLogin.vue?vue&type=script&lang=js&"
export * from "./DeleLogin.vue?vue&type=script&lang=js&"
import style0 from "./DeleLogin.vue?vue&type=style&index=0&id=15e532b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e532b4",
  null
  
)

export default component.exports